/**
 * @generated SignedSource<<dff2ed8be14fe5952a65a02b8075807f>>
 * @relayHash 72243b2854af40ec560930e26c3638f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f4c2cc269ffaf3d0a8dee9e1e3a19793433037fb4f48448e6c0b6eb140af335

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3f4c2cc269ffaf3d0a8dee9e1e3a19793433037fb4f48448e6c0b6eb140af335",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
